import React, { useState, useEffect, lazy } from "react";
import axios from "../../api/axios";
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";

// import luggage from "../../assets/luggage.jpg";
// import cleanings from "../../assets/cleanings.jpg";
// import longterm from "../../assets/longterm.jpg";
import ImageContent from "../dynamic/ImageContent";
const FetchImage = lazy(() => import("../dynamic/fetchImage"));
const WEBSITE_URL = "/dashboard/key";

const Services = () => {
  const { username, auth } = useAuth();
  const { t } = useTranslation();
  const [cleaningService, setCleaningService] = useState("-1");
  const [luggageService, setLuggageService] = useState("-1");
  // const [breakfastService, setBreakfastService] = useState("-1");
  const [longStay, setLongStay] = useState("-1");

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const responseCleaning = await axios.get(WEBSITE_URL, {
          params: {
            username: username,
            key: "cleaningService", 
          },
        });
        const responseLuggage = await axios.get(WEBSITE_URL, {
          params: {
            username: username,
            key: "luggageService", 
          },
        });
        // const responseBreakfast = await axios.get(WEBSITE_URL, {
        //   params: {
        //     username: username,
        //     key: "breakfastService", 
        //   },
        // });
        const responseLongStay = await axios.get(WEBSITE_URL, {
          params: {
            username: username,
            key: "longStay", 
          },
        });
        const content = responseCleaning.data.cleaningService;
        setCleaningService(content);
        const contentLuggage = responseLuggage.data.luggageService;
        setLuggageService(contentLuggage);
        // setBreakfastService(responseBreakfast.data.breakfastService);
        setLongStay(responseLongStay.data.longStay);
      } catch (error) {
        console.error(error);
      }
    };

    fetchContent();
  }, [username]);

  return (
    <div>
      <h2 style={{ marginBottom: "30px" }}>{t("services.title")}</h2>
      <div className=" container other-services-container">
        {luggageService !== "0" && (
          <div className="other-services-item">
            <div className="other-services-image">
              {!auth?.role ? (
                <FetchImage
                  title="image-services1"
                  type="other-services-image"
                />
              ) : (
                <ImageContent
                  title="image-services1"
                  username={username}
                  type="image-about"
                />
              )}
              <span>{t("services.luggage")}</span>
            </div>
            <span className="other-services-span">
              {t("service_codes." + luggageService)}
            </span>
          </div>
        )}

        {cleaningService !== "0" && (
          <div className="other-services-item">
            <div className="other-services-image">
              {!auth?.role ? (
                <FetchImage
                  title="image-services2"
                  type="other-services-image"
                />
              ) : (
                <ImageContent
                  title="image-services2"
                  username={username}
                  type="image-about"
                />
              )}
              <span>{t("services.cleaning")}</span>
            </div>
            <span className="other-services-span">
              {t("service_codes." + cleaningService)}
            </span>
          </div>
        )}

        {longStay !== "0" && (
          <div className="other-services-item">
            <div className="other-services-image">
              {!auth?.role ? (
                <FetchImage
                  title="image-services3"
                  type="other-services-image"
                />
              ) : (
                <ImageContent
                  title="image-services3"
                  username={username}
                  type="image-about"
                />
              )}
              <span>{t("services.long_term")}</span>
            </div>
            <span className="other-services-span">
              {t("service_codes." + longStay)}
            </span>
          </div>
        )}
      </div>
      {/* <div
        className="dog-friendly-home p"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "50px",
        }}
      >
        {breakfastService !== "0" && (
          <div style={{ textAlign: "center" }}>
            <h3>
              <FontAwesomeIcon icon={faUtensils} />
            </h3>
            <h3>{t("services.breakfast")}</h3>
            {t("service_codes." + breakfastService)}
          </div>
        )}
        {luggageService !== "0" && (
          <div style={{ textAlign: "center" }}>
            <h3>
              <FontAwesomeIcon icon={faSuitcase} />
            </h3>
            <h3>{t("services.luggage")}</h3>
            {t("service_codes." + luggageService)}
          </div>
        )}
        {cleaningService !== "0" && (
          <div style={{ textAlign: "center" }}>
            <h3>
              <FontAwesomeIcon icon={faBroom} />
            </h3>
            <h3>{t("services.cleaning")}</h3>
            {t("service_codes." + cleaningService)}
          </div>
        )}
        {longStay !== "0" && (
          <div style={{ textAlign: "center" }}>
            <h3>
              <FontAwesomeIcon icon={faCalendarDays} />
            </h3>
            <h3>{t("services.long_term")}</h3>
            {t("service_codes." + longStay)}
          </div>
        )}
      </div> */}
    </div>
  );
};

export default Services;
